import { Partner } from "../../types";
import { isStateFarmPartner } from "../isStateFarmPartner";

/* Determines if user is a State Farm partner and is logged in via SSO */
export const isStateFarmSso = (partner: Partner, isSso: boolean): boolean => {
  return isSso && isStateFarmPartner(partner);
};
